import NewBusinessdetailForm from "./NewBusinessdetailForm"

const NewBusinessdetail = () => {
  return (
    <section>
      <h2 className="text-xl font-bold mb-4">Create New Businessdetail</h2>
      <NewBusinessdetailForm />
    </section>
  )
}

export default NewBusinessdetail
